import type {FieldPolicy} from '@apollo/client';

import {hasMoreStaff as hasMoreStaffVar} from '../../query/AllStaff.gql';

/**
 * Implementation of local field that indicates whether we can query more staff.
 */
export const hasMoreStaff: FieldPolicy = {
  read() {
    return hasMoreStaffVar();
  },
};
